/**
 * @file input
 */
import InputAntd from 'antd/es/input';
import styled, { css } from 'styled-components';
export const PropsDummy = () => null;
export const Input = styled(InputAntd) `
  ${props => props.underlined &&
    css `
      padding: 4px 0;
      color: rgba(6, 12, 25, 0.85);
      line-height: 24px;
      border-top: none;
      border-right: none;
      border-bottom: 1px solid;
      border-bottom-color: rgb(211, 213, 219);
      border-left: none;
      border-radius: 0;
      outline: none;
      box-shadow: none;
      transition: border-color 0.3s;

      &:hover {
        border-bottom-color: rgba(6, 12, 25, 0.45);
      }

      ::placeholder {
        color: rgba(6, 12, 25, 0.25);
        opacity: 1;
      }
    `}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvSW5wdXQvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUgsT0FBTyxTQUFtQyxNQUFNLGVBQWUsQ0FBQTtBQUcvRCxPQUFPLE1BQU0sRUFBRSxFQUFFLEdBQUcsRUFBRSxNQUFNLG1CQUFtQixDQUFBO0FBUy9DLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBd0IsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFBO0FBaUJ6RCxNQUFNLENBQUMsTUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLFNBQXNCLENBQUMsQ0FBaUI7SUFDaEUsS0FBSyxDQUFDLEVBQUUsQ0FDUixLQUFLLENBQUMsVUFBVTtJQUNoQixHQUFHLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7S0FzQkY7Q0FDSixDQUFBIn0=